import React, { useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
import colors from '../colors/colors.module.css';
import { InputProps } from "./Input.types";
import IconProvider from "../IconProvider";
import ProgressIndicator from "../ProgressIndicator";
import Button from "../Button";
import Typography from "../Typography";
import { CLOSE } from "../../../assets";


const Input: React.FC<InputProps> = ({Tooltip , size , className, showCloseIcon = true, IconStyle, ContainerclassName,disabled=false, onChange, placeHolder, title, value, iconStart, type, inputStyle, isRequired, isRequiredText, error , containerStyle}: InputProps) => {
  const [focus, setFocus] = useState(false);
  const [val, setVal] = useState(value);
  const updateVal = (val:any) => {
    /* Make update synchronous, to avoid caret jumping when the value doesn't change asynchronously */
    setVal(val.target.value);
    /* Make the real update afterwards */
    onChange(val); setFocus(true) 
  };

  React.useEffect(() => {

    setVal(value);
 
   }, [value])

  return <div className={clsx(styles.input, ContainerclassName && ContainerclassName)} style={containerStyle && containerStyle}> 
    {title && <Typography weight="Body_Small_Regular" text={ title } style={{color:"#484848" ,display:"flex",flexDirection:"row",justifyContent :"center" , alignItems :"center"}} />}

  <div className={clsx(styles.inputContainer , size && styles[size] , disabled && styles.disabled, focus && styles.focus, (error && (value || String(value).length > 0)) && styles.errorBorder)}>
    {iconStart && <IconProvider Icon={iconStart} style={IconStyle ? IconStyle : {}} />}
    <input disabled={disabled} type={type} placeholder={placeHolder} onFocus={() => { setFocus(true) }} onBlur={() => { setFocus(false) }} className={className} value={val} onChange={(e) => { updateVal(e); setFocus(true) }} style={inputStyle && inputStyle} onClick={() => { setFocus(true) }} />
    {(isRequired && (!value || String(value).length == 0)) && <span className={styles.isRequired}> {isRequiredText} </span>}
    {(value != null && String(value).length > 0 && !disabled && showCloseIcon) && <IconProvider Icon={CLOSE} size="12" style={{ cursor: "pointer" }} onClick={()=>{onChange({target:{value:null}}) ; setFocus(false) ; }} />}
    {(Tooltip && !value != null && String(value).length == 0) && Tooltip }

  </div>
    {(error && (value || String(value).length > 0)) && <span className={styles.error}> {error} </span>}

  </div>
};

export default Input;

